<template><!-- svgo-optimised -->
<svg class="icon icon__pause" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14 19V5h4v14zm-8 0V5h4v14z" fill="currentColor"/></svg></template>